/* @flow */
import React from 'react';
import Legend from 'components/Legend';
import Divider from 'components/Divider';
import Checkbox from 'components/Checkbox';
import SettingsContainer from './SettingsContainer';
import PreferredVoiceCallDeviceContainer from './PreferredVoiceCallDeviceContainer';
import { showToast } from 'reducers/toasts';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

type Props = {
  value: string,
  persisted: boolean,
  persistError: ?Error,
  isTeacher: boolean,
  enable: () => void,
  disable: () => void,
  showToast: (text: string, kind: 'success' | 'error') => void,
};

class PhoneCallPreferenceSection extends React.Component<Props> {
  componentWillReceiveProps(nextProps: Props) {
    if (!this.props.persisted && nextProps.persisted) {
      this.props.showToast('Phone call option was saved.', 'success');
    }

    if (!this.props.persistError && nextProps.persistError) {
      this.props.showToast('Oops, could not save phone call option.', 'error');
    }
  }

  handleValueChange = (event: *): void => {
    if (event.target.checked) {
      this.props.enable();
    } else {
      this.props.disable();
    }
  };

  render() {
    return (
      <div>
        <Divider />
        <Legend>
          Call preferences
          {this.props.isTeacher && (
            <p>Teachers, students and parents can only call you during your office hours.</p>
          )}
        </Legend>
        <SettingsContainer>
          <Checkbox
            checked={this.props.value === 'enabled'}
            onChange={this.handleValueChange}
            label="Receive calls through Remind"
          />
          {this.props.value === 'enabled' && <PreferredVoiceCallDeviceContainer />}
        </SettingsContainer>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowFixMe
  return bindActionCreators({ showToast }, dispatch);
}

export { PhoneCallPreferenceSection };
export default connect(undefined, mapDispatchToProps)(PhoneCallPreferenceSection);
